import { /* baseClient, */ authClient, API } from "../../utils/index";
import { uploadSingleFile } from "../files";

// Get all regattas
export const getRegattas = () => {
	return authClient().get(`${API}/regatta`);
};

// Get regatta by id
export const getRegattaById = (id) => {
	return authClient().get(`${API}/regatta/${id}`);
};

// Delete regatta
export const deleteRegatta = (id) => {
	return authClient().delete(`${API}/regatta/${id}`);
};

export const resetRegattaStats = (id) => {
	return authClient().delete(`${API}/regatta/reset-stats/${id}`);
};

// Create regatta
export const postRegatta= async (regatta, image, file1, file2) => {
	if (image) {
		const fileURL = await uploadSingleFile(image, "regattas");
		regatta.sponsor.logo = fileURL.data.fileURL;
	}
	if (file1) {
		const fileURL = await uploadSingleFile(file1, "regattas");
		regatta.instructions = fileURL.data.fileURL;
	}
	if (file2) {
		const fileURL = await uploadSingleFile(file2, "regattas");
		regatta.announcement = fileURL.data.fileURL;
	}
	return authClient().post(`${API}/regatta`, regatta);
};

// Update regatta
export const updateRegatta = async (id, regatta, image, file1, file2) => {
	if (image) {
		const response = await uploadSingleFile(image, "regattas");
		regatta.sponsor.logo = response.data.fileURL;
	}
	if (file1) {
		const fileURL = await uploadSingleFile(file1, "regattas");
		regatta.instructions = fileURL.data.fileURL;
	}
	if (file2) {
		const fileURL = await uploadSingleFile(file2, "regattas");
		regatta.announcement = fileURL.data.fileURL;
	}
	return authClient().put(`${API}/regatta/${id}`, regatta);
};

// Set default regatta
export const setDefaultRegatta = (id) => {
	return authClient().put(`${API}/regatta/set-default/${id}`);
};

// Get wind forecast for regatta by ID
export const getWindForecast = (id) => {
	return authClient().get(`${API}/wind/${id}`);
};
